
        var result = require("!!../../../../node_modules/css-loader/index.js!./ticket.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/manage/ticket/ticket.component.css
// module id = 734
// module chunks = 0